module.exports = __webpack_public_path__ + "img/108.7.432f708b.png";